export default "__VITE_ASSET__8f689042__"